import { DataLoader } from "styles/jss/Layout.styles";
import { PropagateLoader } from "react-spinners";

export default function Loader() {
  return (
    <DataLoader className={"loader"}>
      <PropagateLoader className={"loader"} color="#17479e" />
    </DataLoader>
  );
}
